import React from 'react';
import { SharedNavbar } from '../components/SharedNavbar';
import { HeroAbout } from '../components/HeroAbout';
import { MyStory } from '../components/MyStory';
import { Mission } from '../components/Mission';
import { Credentials } from '../components/Credentials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function DespreMinePage() {
  return <>
      <SharedNavbar data-id="element-934" />
      <main className="flex-grow" data-id="element-935">
        <HeroAbout data-id="element-936" />
        <MyStory data-id="element-937" />
        <Mission data-id="element-938" />
        <Credentials data-id="element-939" />
        <FinalCTA data-id="element-940" />
      </main>
      <Footer data-id="element-941" />
    </>;
}